// extracted by mini-css-extract-plugin
module.exports = {"titleText":"e_4w","container":"e_5w","authorText":"e_6w","title":"e_7w","image":"e_8w","description":"e_9w","author":"e_-w","splitLine":"e_ax"};